module.exports = __webpack_public_path__ + "img/DE02845.ed7fb95f.png";